import React, { useState, useEffect, useRef } from "react";
import { Select, Card, Modal, Button, Table, Tag, Collapse, message, Badge, Form, Input, InputNumber, Tooltip, Divider, Checkbox, Radio } from 'antd';
import axios from 'axios';
import config from "../config";
import Swal from 'sweetalert2';
import { formatReceiptData, printToKitchen } from '../components/ReceiptData';
import { io } from 'socket.io-client';
import CloseButton from "../components/CloseButton";
import QRCode from 'qrcode.react';
import {
    DeleteOutlined,
    CheckOutlined,
    EditOutlined,
} from "@ant-design/icons";
import { getCurrencySymbol } from '../utils/currencyHelper';
import { useCurrency } from "../contexts/ValidationContext"
import { size } from "lodash";

const QueList = ({ tables, restaurantName, imageLogo, restaurantAddress }) => {
    const apiBaseUrl = config.REACT_APP_API_BASE_URL;
    const apiEndUserBaseUrl = config.REACT_APP_ENDUSER_API_BASE_URL;
    // const apiBaseUrl = "http://localhost:8080";
    // const apiEndUserBaseUrl = "http://localhost:3200";

    const [tableNumber, setTableNumber] = useState('Queue');
    const [tableOrders, setTableOrders] = useState({ orders: [] });
    const [firstOrderIDs, setFirstOrderIDs] = useState({});
    const [currentTick, setCheckCurrentTick] = useState({});
    const [queCount, setQueCount] = useState(0);
    const [open, setOpen] = useState(false);
    const [activeKeys, setActiveKeys] = useState([]);
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(false);
    const [qrVisible, setQrVisible] = useState(false);
    const [taxes, setTaxes] = useState([]);
    const { Panel } = Collapse;
    const [editOrderVisible, setEditOrderVisible] = useState(false);
    const [currentOrder, setCurrentOrder] = useState(null);
    const [subMenu, setSubMenu] = useState([]);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [addOnOrders, setAddOnOrders] = useState([]);
    const { currency } = useCurrency();
    const [order, setOrder] = useState(null);
    const [currentUser, setCurrentUser] = useState(null);
    const [assignQue, setAssignQue] = useState(false);
    const symbol = getCurrencySymbol(currency);
    const [selectedTable, setSelectedTable] = useState('');

    const [selectedTableOrders, setSelectedTableOrders] = useState([]);
    const [areAllCollapsed, setAreAllCollapsed] = useState(true);



    const validateQuantity = () => {
        if (!currentOrder) {
            return {
                validateStatus: "error",
                errorMsg: "Order data is missing.",
            };
        }

        const quantity = currentOrder.quantity;

        // Immediate validation for invalid values (non-numbers or <= 0)
        if (quantity <= 0 || typeof quantity !== "number") {
            return {
                validateStatus: "error",
                errorMsg: "Please input the right quantity!",
            };
        }

        // Delay validation for null until form submission
        if (quantity === null && isSubmitted) {
            return {
                validateStatus: "error",
                errorMsg: "Please input the right quantity!",
            };
        }

        return {
            validateStatus: "success",
            errorMsg: null,
        };
    };

    const { validateStatus, errorMsg } = validateQuantity();

    const getTotalItems = () => {
        return orders
            .reduce((total, order) => {
                if (Array.isArray(order.order_items)) {
                    return (
                        total +
                        order.order_items.reduce((acc, curr) => {
                            return acc + (curr.quantity || 0); // Default to 0 if undefined
                        }, 0)
                    );
                }
                return total; // If order.result is not an array, return the current total
            }, 0)
            .toFixed(0);
    };
    const totalItems = getTotalItems();

    const handleQrToken = async (tableNumber) => {
        const { data } = await axios.post(`${apiBaseUrl}/api/tables/getTableOrderUrlToken`, { tableNumber });
        if (data.token) {
            console.log(data.token);
            const token = data.token;
            return token;
        } else {
            return null;
        }
    }

    const printQrCode = async (tableNumber) => {
        const selectedPrinterId = localStorage.getItem("selectedPrinterId");
        console.log('selectedPrinterId in printQrCode: ', selectedPrinterId);

        try {// Prepare qrCodeRequest for backend
            const qrCodeRequest = {
                logo: imageLogo,
                resName: restaurantName,
                address: restaurantAddress,
                URL: `${apiEndUserBaseUrl}/shop?table=${tableNumber}`,
                tableNumber,
                selectedPrinterId: selectedPrinterId
            };

            // Send the payload to the backend API
            const response = await axios.post(
                `${config.REACT_APP_API_BASE_URL}/api/printqrcode`,
                qrCodeRequest,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${JSON.parse(localStorage.getItem("auth")).token}`,
                    },
                }
            );

            if (response.data.success) {
                message.success("QR Code sent to printer successfully!");
            } else {
                throw new Error(response.data.message || "Printing failed");
            }
        } catch (error) {
            console.error("Printing error:", error);
            message.error("Failed to send notification for printing: " + (error.response?.data?.message || error.message));
        }
    }


    const handleCancel = () => {
        setOpen(false);
        window.history.replaceState(null, '', '/');
    };

    const hideQrModal = () => {
        setQrVisible(false);
    };

    const hideAssignQue = () => {
        setAssignQue(false);
    };

    const showAssignQue = () => {
        setAssignQue(true);
    };

    const showQrModal = () => {
        setQrVisible(true);
    };

    // assignTableCheck = () => {
    //     if (!selectedTableOrders){}
    // }

    const assignTableSubmit = async () => {
        if (selectedTableOrders.length === 0 || !selectedTable) {
            console.warn('No orders selected or no table selected for updating.');
            return;
        }

        const ordersToUpdate = selectedTableOrders.map(orderId => ({
            orderId,
            order_tablenumber: selectedTable,
        }));

        try {
            const response = await axios.put(`${apiBaseUrl}/api/orders/update-queue-order`, {
                orders: ordersToUpdate,
            });

            if (response.status === 200) {

                Swal.fire({
                    title: 'Success',
                    text: 'Order status updated successfully',
                    toast: true,
                    icon: 'success',
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                });

                hideAssignQue();
                setSelectedTableOrders([]);
            } else {
                console.error('Some orders failed to update');
            }
        } catch (error) {
            console.error('API error:', error);
        }
    };


    useEffect(() => {
        console.log(selectedTableOrders)
    }, [selectedTableOrders]);

    const handleEditOrder = (order) => {
        console.log('OOOOOOOOOO', order);
        setCurrentOrder(order);
        setEditOrderVisible(true);
    };

    const calculateTotalWithTaxes = (order) => {
        const totalWithoutTax = order.order_items.reduce(
            (acc, curr) => acc + curr.product.price * curr.quantity,
            0
        );
        const totalTax = taxes.reduce((acc, tax) => acc + totalWithoutTax * (tax.rate / 100), 0);
        return (totalWithoutTax + totalTax).toFixed(2);
    };

    const handleCollapseToggle = () => {
        setAreAllCollapsed((prev) => !prev);

        if (areAllCollapsed) {
            // If currently collapsed, expand all
            setActiveKeys(orders.map((order) => order.oid));
        } else {
            // If currently expanded, collapse all
            setActiveKeys([]);
        }
    };

    const handleOk = () => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            setOpen(false);
        }, 3000);
    };


    const handleSelectAll = () => {
        // Get all orders for the current table number
        const tableOrdersForCurrentTable = tableOrders[tableNumber] || [];

        // Get the currently selected orders from localStorage
        const storedSelectedOrders = JSON.parse(localStorage.getItem('selectedTableOrders')) || [];

        // Extract the IDs of the orders to be selected
        const allOrderIds = tableOrdersForCurrentTable.map(order => order.oid);

        // Merge the selected orders with previously selected ones, ensuring no duplicates
        const updatedSelectedOrders = [
            ...new Set([
                ...storedSelectedOrders, // Existing selected orders
                ...allOrderIds           // Newly selected orders for the current table
            ])
        ];

        // Update the selected orders state and localStorage
        setSelectedTableOrders(updatedSelectedOrders);
        localStorage.setItem('selectedTableOrders', JSON.stringify(updatedSelectedOrders));
    };


    const handleUpdateOrder = async (order_items, order) => {
        console.log("order_items:", order_items);
        console.log("order:", order);

        // Validate input
        if (!order_items._id || order_items.quantity < 0 || typeof order_items.quantity !== "number") {
            message.error("Please provide a valid quantity.");
            Swal.fire({
                icon: 'error',
                text: 'Please provide a valid quantity.',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
            });
            setEditOrderVisible(true); // Keep modal open if validation fails
            return;
        }

        if (order_items.remarks && typeof order_items.remarks !== "string") {
            // message.error("Please provide a valid remark.");
            Swal.fire({
                icon: 'error',
                text: 'Please provide a valid remark.',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
            });
            setEditOrderVisible(true); // Keep modal open if validation fails
            return;
        }
        // Validate required submenu items
        const requiredGroups = subMenu.filter((item) => item.requirement === "required");
        // console.log("Required Groups:", requiredGroups); // Log required groups

        const reportedGroups = new Set();

        for (const groupItem of requiredGroups) {
            if (reportedGroups.has(groupItem.group)) continue;

            const groupItems = subMenu.filter(item => item.group === groupItem.group);
            const isGroupChecked = groupItems.some(groupItem => {
                return groupItem.items.some(item => {
                    const isItemSelected = order_items.product.addOns.some(addOn => {
                        return addOn.group === groupItem.group && addOn.name === item.name;
                    });
                    return isItemSelected;
                });
            });

            if (!isGroupChecked) {
                // message.error(`${groupItem.group} needs to be selected at least once.`);
                Swal.fire({
                    icon: 'error',
                    text: `${groupItem.group} needs to be selected at least once.`,
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                });
                reportedGroups.add(groupItem.group); // Track group to prevent multiple error messages
                setEditOrderVisible(true); // Keep modal open if group validation fails
                return; // Stop execution if no item is selected in the required group
            }
        }

        try {
            const payload = {
                _id: order._id,
                orderItems_id: order_items._id,
                quantity: order_items.quantity,
                addOns: order_items.product.addOns.map((addOn) => ({
                    id: addOn.id,
                    name: addOn.name,
                    price: addOn.price,
                    group: addOn.group,
                })) || [],
                remarks: order_items.remarks,
                voidReason: order_items.void_reason,
                tableNumber,
                logo: imageLogo,
                resName: restaurantName,
                address: restaurantAddress,
                cashierName: currentUser,
                totalItems: totalItems,
            };

            const response = await axios.put(`${apiBaseUrl}/api/orders/update-order-array`, payload);

            if (response.status === 200) {
                // message.success("Order item updated successfully!");
                Swal.fire({
                    title: 'Success',
                    text: 'Order updated successfully!',
                    toast: true,
                    icon: 'success',
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                });

                setAddOnOrders(prev => [...prev, { ...order_items, action: 'updated' }]);
                fetchTableOrders();

                setEditOrderVisible(false); // Close modal if update is successful
            } else {
                // message.error(response.data.message || "Failed to update order item.");
                Swal.fire({
                    icon: 'error',
                    text: response.data.message || "Failed to update order.",
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                });

                setEditOrderVisible(true); // Keep modal open if update failed
            }
        } catch (error) {
            // message.error(error.response?.data?.message || "Something went wrong while updating the order item.");
            Swal.fire({
                icon: 'error',
                text: error.response?.data?.message || "Something went wrong while updating the order.",
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
            });
            setEditOrderVisible(true); // Keep modal open if an error occurred
        }
    };

    const handleDeleteOrder = async (order, order_items, reason) => {
        try {
            await axios.post(`${apiBaseUrl}/api/orders/delete-order`, { orderId: order._id, orderItems_id: order_items._id, currentUser: currentUser, voidReason: reason, });
            // message.success('Order Deleted Successfully');
            Swal.fire({
                title: 'Success',
                text: 'Order Deleted Successfully',
                toast: true,
                icon: 'success',
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000
            });

            // Add to add-on orders
            setAddOnOrders(prev => [...prev, { ...order_items, action: 'canceled' }]);

            fetchTableOrders();
        } catch (error) {
            // message.error('Something Went Wrong');
            Swal.fire({
                icon: 'error',
                title: 'Failed to delete order. Please try again.',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
            });
        }
    };

    const handleDeselectAll = () => {
        // Get the currently selected orders from localStorage
        const storedSelectedOrders = JSON.parse(localStorage.getItem('selectedTableOrders')) || [];

        // Get all orders for the current table number
        const tableOrdersForCurrentTable = tableOrders[tableNumber] || [];

        // Extract the IDs of the orders to be deselected
        const allOrderIds = tableOrdersForCurrentTable.map(order => order.oid);

        // Remove the current table's orders from the selected orders
        const updatedSelectedOrders = storedSelectedOrders.filter(
            (orderId) => !allOrderIds.includes(orderId)
        );

        // Update the selected orders state and localStorage
        setSelectedTableOrders(updatedSelectedOrders);
        localStorage.setItem('selectedTableOrders', JSON.stringify(updatedSelectedOrders));
    };

    const handleCheckboxChange = (event, orderId) => {
        setSelectedTableOrders((prevOrders) => {
            const safePrevOrders = Array.isArray(prevOrders) ? prevOrders : [];
            const updatedOrders = event.target.checked
                ? [...new Set([...safePrevOrders, orderId])]
                : safePrevOrders.filter((id) => id !== orderId);

            localStorage.setItem('selectedTableOrders', JSON.stringify(updatedOrders));
            return updatedOrders;
        });
    };

    const fetchTableOrders = async () => {
        try {
            let fetchedTableOrders = [];
            const { data: ordersData } = await axios.get(`${apiBaseUrl}/api/orders/get-order?table=${tableNumber}`);

            ordersData.forEach(order => {
                const { order_tablenumber } = order;
                // console.log("Processing order:", order); // Log the current order being processed

                if (!fetchedTableOrders[order_tablenumber]) {
                    // console.log(`Table ${order_tablenumber} not found in fetchedTableOrders. Initializing array.`); // Log when initializing
                    fetchedTableOrders[order_tablenumber] = [];
                }

                // console.log(`Adding order to table ${order_tablenumber}:`, order); // Log the order being added
                fetchedTableOrders[order_tablenumber].push(order);
            });
            setTableOrders(fetchedTableOrders);

            setQueCount(ordersData.length);

            const tableOrdersData = fetchedTableOrders[tableNumber] || [];
            setOrders(tableOrdersData);
            console.log(orders);
            // console.log("Check table order:", tableOrders);
            // Loop through all fetched orders and handle the first order of each table
            // console.log("Fetch Table Number:", fetchedTableOrders); 
            for (const tableNumber in fetchedTableOrders) {
                // console.log("Table Number:", tableNumber); 
                const tableOrders = fetchedTableOrders[tableNumber];
                // console.log(`Table:`, tableOrders,tableNumber);
                if (tableOrders.length >= 0) {
                    const orderIds = tableOrders.map(order => order.oid);
                    // console.log(`Order IDs for table ${tableNumber}:`, orderIds);

                    const firstOrderId = orderIds[0];
                    // console.log(`First Order ID for table ${tableNumber}:`, firstOrderId);

                    // Filter and find matching order IDs in selectedOrders
                    // const matchingOrders = orderIds.filter(orderId => selectedOrders.includes(orderId));

                    // Update checkCurrentTick state with matching order IDs for the current table
                    const filteredOrderIds = tableOrders
                        .filter(order => order.order_progressstatus !== "Receive") // Only include orders where progress status is not "Receive"
                        .map(order => order.oid); // Extract order IDs

                    // Update checkCurrentTick state with matching order IDs for the current table
                    setCheckCurrentTick((prevState) => {
                        const updatedState = {
                            ...prevState,
                            [tableNumber]: filteredOrderIds, // Add the table with its filtered orders
                        };

                        // console.log("Updated checkCurrentTick:", updatedState); // Log the updated state
                        return updatedState;
                    });
                    // console.log(`Check How Many ${tableNumber}:`, matchingOrders);
                    // Update the firstOrderIDs state with the first order for the current table
                    setFirstOrderIDs((prevState) => ({
                        ...prevState,
                        [tableNumber]: firstOrderId,
                    }));

                }
            }
        } catch (error) {
            // console.log("Error fetching table orders:", error);
            message.error("Error fetching table orders", error);
        }
    };

    const handlePanelChange = (keys) => {
        setActiveKeys(keys); // Update active keys when individual panels are toggled
    };

    const voidEntireOrder = async (orderId) => {
        const { value: voidReason } = await Swal.fire({
            title: "Warning",
            text: "Are you sure you want to void this order?",
            input: "select",
            inputLabel: "Reason for voiding",
            inputOptions: {
                hygiene_problem: "Hygiene Problem",
                waiting_too_long: "Waiting too long",
                wrong_item: "Wrong item",
                other: "Other"
            },
            inputPlaceholder: "Select a reason",
            inputValidator: (value) => {
                if (!value) {
                    return "You must select a reason!";
                }
            },
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes"
        });

        if (voidReason) {
            try {
                const response = await fetch(`${apiBaseUrl}/api/orders/void-entire-order`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${JSON.parse(localStorage.getItem("auth")).token}`
                    },
                    body: JSON.stringify({
                        orderId,
                        currentUser,
                        voidReason
                    })
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                const result = await response.json();

                if (response.ok) {
                    Swal.fire({
                        title: "Success",
                        text: "The order has been voided.",
                        toast: true,
                        icon: "success",
                        position: "top-end",
                        showConfirmButton: false,
                        timer: 3000,
                    });
                    // Refresh data
                    fetchTableOrders();
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: result.message || "Failed to void order",
                        icon: "error"
                    });
                }
            } catch (error) {
                Swal.fire({
                    title: "Network Error!",
                    text: "Could not connect to server",
                    icon: "error"
                });
                console.error('Error:', error);
            }
        }
    };

    useEffect(() => {
        // const socket = io('http://localhost:8080');

        let socketUrl;
        try {
            socketUrl = apiBaseUrl;
        } catch {
            socketUrl = apiBaseUrl;
        }

        const socket = io(socketUrl);

        socket.on('newOrder', (order) => {
            fetchTableOrders();
        });

        return () => socket.disconnect();
    }, []);

    useEffect(() => {
        fetchTableOrders();
        console.log('Queue')
    }, []);

    return (
        <div>
            <Button type="primary" danger size="large"
                key="back"
                onClick={() => setOpen(true)}
            >
                ({queCount}) Queue
            </Button>

            <Modal
                open={open}
                title={
                    <div>
                        <CloseButton onClick={handleCancel} />
                        <div className="tablePadding">{`Queue List`}</div>
                        <Divider />
                        <div className="showButtonOnTop" style={{ display: "flex" }}>
                            {/* Select All Button */}
                            <Button
                                type="default"
                                onClick={handleSelectAll}
                                disabled={
                                    Array.isArray(selectedTableOrders) &&
                                    (tableOrders[tableNumber] || []).every(order =>
                                        selectedTableOrders.includes(order.oid)
                                    )
                                }
                            >Select All</Button>

                            {/* Deselect All Button */}
                            <Button
                                type="default"
                                onClick={handleDeselectAll}
                                disabled={
                                    Array.isArray(selectedTableOrders) &&
                                    !(tableOrders[tableNumber] || []).some(order =>
                                        selectedTableOrders.includes(order.oid)
                                    )
                                }
                                style={{ marginLeft: 8 }}
                            >Deselect All</Button>
                            <Button
                                type="default"
                                onClick={handleCollapseToggle}
                                disabled={
                                    !Object.keys(tableOrders).some(
                                        (tableNum) =>
                                            tableNum === `Queue`
                                    )
                                }
                                style={{ marginLeft: 8 }}
                            >
                                {areAllCollapsed ? "Reopen All" : "Collapse All"}
                            </Button>
                        </div>
                    </div>

                }
                onOk={handleOk}
                onCancel={handleCancel}
                width={1000}
                className="fixed-footer"
                footer={[
                    <Button
                        key="showQR"
                        type="default"
                        onClick={showQrModal}
                    >
                        Show QR
                    </Button>,

                    <Button
                        key="back"
                        onClick={async () => {
                            const token = await handleQrToken(tableNumber);
                            if (token) {
                                window.open(`${apiEndUserBaseUrl}/shop?table=${tableNumber}&token=${token}`, '_blank');
                            }
                        }}
                    >
                        Order More
                    </Button>,

                    <Button
                        key="assignQue"
                        onClick={showAssignQue}
                        disabled={selectedTableOrders.length === 0}
                    >
                        Assign Table
                    </Button>,

                ]}
            >
                <Collapse
                    activeKey={activeKeys}
                    // onChange={onChange}
                    onChange={handlePanelChange}
                // collapsible="icon"
                >

                    {orders.map((order) => {
                        const totalWithTaxes = calculateTotalWithTaxes(order); // Calculate total with taxes for the current order

                        // Only render the Panel if the total with taxes is greater than 0
                        if (totalWithTaxes > 0) {
                            return (
                                <Panel
                                    className="panelDesign"
                                    header={
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <input
                                                type="checkbox"
                                                checked={selectedTableOrders.includes(order.oid)}
                                                onChange={(e) => handleCheckboxChange(e, order.oid)}
                                                style={{ marginRight: '8px' }}
                                            />

                                            <strong>Order ID: #{order.oid}</strong>
                                            {order.contact && <strong style={{ marginLeft: "5%" }}>Contact: {order.contact}</strong>}
                                            <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
                                                <button
                                                    // onClick={() => console.log('Button clicked for order', order.oid)}
                                                    onClick={() => voidEntireOrder(order._id, currentUser)}
                                                    style={{
                                                        backgroundColor: '#e53e3e', // red tone
                                                        color: '#fff',
                                                        padding: '4px 16px',
                                                        border: 'none',
                                                        borderRadius: '6px',
                                                        cursor: 'pointer',
                                                        fontWeight: 'bold',
                                                        marginRight: '20px',
                                                        transition: 'background-color 0.3s ease',
                                                    }}
                                                    onMouseOver={(e) => e.target.style.backgroundColor = '#c53030'}
                                                    onMouseOut={(e) => e.target.style.backgroundColor = '#e53e3e'}
                                                >
                                                    Void
                                                </button>

                                                <Badge
                                                    className="badgeStyle"
                                                    status={
                                                        order.order_progressstatus === ""
                                                            ? "error"
                                                            : order.order_progressstatus === "Kitchen"
                                                                ? "warning"
                                                                : order.order_progressstatus === "Receive"
                                                                    ? "success"
                                                                    : "default"
                                                    }
                                                />
                                            </div>
                                        </div>

                                    }
                                    key={order.oid}
                                >

                                    <Table
                                        bordered
                                        pagination={false}
                                        columns={[
                                            {
                                                title: 'No',
                                                key: 'index',
                                                render: (text, record, recordIndex) => (
                                                    <span>{recordIndex + 1}</span>
                                                ),
                                            },
                                            {
                                                title: 'Food Name',
                                                dataIndex: 'product',
                                                render: (product) => product.name,
                                            },
                                            {
                                                title: 'Price (' + symbol + ')',
                                                dataIndex: 'product',
                                                render: (product) => `${symbol}${parseFloat(product.price).toFixed(2)}`,
                                            },
                                            {
                                                title: 'Quantity',
                                                dataIndex: 'quantity',
                                                render: (quantity) => quantity,
                                            },
                                            {
                                                title: 'Sub Menu',
                                                dataIndex: 'product',
                                                render: (product) => {
                                                    if (!product.addOns || product.addOns.length === 0) {
                                                        return null;
                                                    }

                                                    const groupedSubMenu = product.addOns.reduce((acc, item) => {
                                                        if (!acc[item.group]) {
                                                            acc[item.group] = [];
                                                        }
                                                        acc[item.group].push(item);
                                                        return acc;
                                                    }, {});

                                                    return (
                                                        <ul>
                                                            {Object.entries(groupedSubMenu).map(([group, items]) => (
                                                                <li key={group}>
                                                                    <strong>{group}</strong>
                                                                    <ul>
                                                                        {items.map((item, index) => (
                                                                            <li key={index}>
                                                                                {item.name} : {symbol} {parseFloat(item.price).toFixed(2)}
                                                                            </li>
                                                                        ))}
                                                                    </ul>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    );
                                                },
                                            },

                                            {
                                                title: 'Remark',
                                                dataIndex: 'remarks',
                                                render: (remarks) => remarks,
                                            },
                                            {
                                                title: "Status",
                                                dataIndex: "order.order_progressstatus",
                                                render: (order_progressstatus) => {
                                                    let displayText = "";
                                                    let color = "";
                                                    let backgroundColor = "";
                                                    let borderColor = "";

                                                    if (order.order_progressstatus === "") {
                                                        displayText = "Ordered";
                                                        color = "#d4380d";
                                                        backgroundColor = "#fff2e8";
                                                        borderColor = "#ffbb96";
                                                    } else if (order.order_progressstatus === "Kitchen") {
                                                        displayText = "Sent to Kitchen";
                                                        color = "#d4b106";
                                                        backgroundColor = "#fffbe6";
                                                        borderColor = "#ffe58f";
                                                    } else if (order.order_progressstatus === "Receive") {
                                                        displayText = "Delivered";
                                                        color = "green";
                                                        backgroundColor = "#f6ffed";
                                                        borderColor = "#b7eb8f";
                                                    }

                                                    return (
                                                        <Tag
                                                            style={{
                                                                color: color,
                                                                backgroundColor: backgroundColor,
                                                                borderColor: borderColor,
                                                            }}
                                                        >
                                                            {displayText}
                                                        </Tag>
                                                    );
                                                },
                                            },
                                            {
                                                title: "Total Price(" + symbol + ")",
                                                dataIndex: "product",
                                                render: (product, record) => {
                                                    const productTotal = product.price * record.quantity;

                                                    let addOnsTotal = 0;
                                                    if (product.addOns) {
                                                        if (product.category === "Combo") {
                                                            // For combo items: only add prices for custom options (from empty groups)
                                                            // Standard menu items (from named groups) are included in combo price
                                                            addOnsTotal = product.addOns.reduce((sum, addon) => {
                                                                // Only add price if it's a custom option (has id from timestamp, not _id from database)
                                                                // Standard menu items (with _id) have their pricing disabled
                                                                const isCustomOption = addon.isCategoryItem ? false : (addon.id && !addon._id);
                                                                return isCustomOption ? sum + (parseFloat(addon.price) * record.quantity) : sum;
                                                            }, 0);
                                                        } else {
                                                            // For regular items, add all add-on prices
                                                            addOnsTotal = product.addOns.reduce((sum, item) => sum + (parseFloat(item.price) * record.quantity), 0);
                                                        }
                                                    }

                                                    const totalPrice = productTotal + addOnsTotal;
                                                    return <span>{symbol}{totalPrice.toFixed(2)}</span>;
                                                },
                                            },
                                            {
                                                title: "Actions",
                                                dataIndex: "order.order_progressstatus",
                                                render: (order_progressstatus, record) => {
                                                    // console.log("record:", record); // Log the entire record
                                                    // console.log("status:", order.order_progressstatus); // Log the specific property

                                                    return (
                                                        // <div className="actions-column">
                                                        //   {/* {order.order_progressstatus !== "Receive" ? ( */}
                                                        //     <>
                                                        //       <EditOutlined
                                                        //         style={{ cursor: 'pointer' }}
                                                        //         onClick={() => {handleEditOrder(record); setOrder(order)}}
                                                        //       />
                                                        //       <Popconfirm
                                                        //         title="Are you sure you want to delete this record?"
                                                        //         onConfirm={() => handleDeleteOrder(order, record)}
                                                        //         okText="Yes"
                                                        //         cancelText="No"
                                                        //       >
                                                        //         <DeleteOutlined
                                                        //           style={{ cursor: "pointer", marginLeft: 8 }}
                                                        //         />
                                                        //       </Popconfirm>
                                                        //     </>
                                                        //   {/* ) : (
                                                        //     <span style={{ color: 'gray' }}></span>
                                                        //   )} */}
                                                        // </div>

                                                        <div className="actions-column">
                                                            <>
                                                                <EditOutlined
                                                                    style={{ cursor: 'pointer' }}
                                                                    onClick={() => {
                                                                        handleEditOrder(record);
                                                                        setOrder(order);
                                                                    }}
                                                                />
                                                                <DeleteOutlined
                                                                    style={{ cursor: 'pointer', marginLeft: 8 }}
                                                                    onClick={async () => {
                                                                        const { value: reason, isConfirmed } = await Swal.fire({
                                                                            title: "Warning",
                                                                            text: "Are you sure you want to void this item?",
                                                                            input: "select",
                                                                            inputLabel: "Reason for voiding",
                                                                            inputOptions: {
                                                                                hygiene_problem: "Hygiene Problem",
                                                                                waiting_too_long: "Waiting too long",
                                                                                wrong_item: "Wrong item",
                                                                                other: "Other"
                                                                            },
                                                                            inputPlaceholder: "Select a reason",
                                                                            inputValidator: (value) => {
                                                                                if (!value) {
                                                                                    return "You must select a reason!";
                                                                                }
                                                                            },
                                                                            icon: "warning",
                                                                            showCancelButton: true,
                                                                            confirmButtonColor: "#3085d6",
                                                                            cancelButtonColor: "#d33",
                                                                            confirmButtonText: "Yes"
                                                                        });

                                                                        if (isConfirmed && reason) {
                                                                            handleDeleteOrder(order, record, reason);
                                                                        }
                                                                    }}
                                                                />

                                                            </>
                                                        </div>
                                                    );
                                                },
                                            },
                                        ]}
                                        dataSource={order.order_items || []}
                                    />
                                </Panel>
                            );
                        }
                    })}
                </Collapse>

                <br></br>

                <Collapse
                    activeKey={activeKeys}
                    onChange={handlePanelChange}
                // collapsible="icon"
                >

                    {orders
                        .filter(order => order.void_items && order.void_items.length > 0 && order.order_voidstatus == false)
                        .map((order) => {

                            return (
                                <Panel
                                    className="panelDesign"
                                    style={{ backgroundColor: '#b9b9b9' }}
                                    header={
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            {/* <input
                          type="checkbox"
                          checked={selectedTableOrders.includes(order.oid)}
                          onChange={(e) => {
                            handleCheckboxChange(e, order.oid);
                          }}
                          style={{ marginRight: '8px' }} // Optional spacing
                        /> */}

                                            <strong>Order ID: #{order.oid}</strong>
                                            <div className="badgeStyle">
                                                <span style={{
                                                    backgroundColor: '#FFEAEB',
                                                    color: 'red',
                                                    padding: '5px 10px',
                                                    borderRadius: '12px',
                                                    fontWeight: 'bold',
                                                    fontSize: '12px',
                                                    textAlign: 'center',
                                                    display: 'inline-block',
                                                }}>Voided</span>
                                            </div>
                                        </div>
                                    }
                                    key={order.oid}
                                >

                                    <Table
                                        bordered
                                        pagination={false}
                                        columns={[
                                            {
                                                title: 'No',
                                                key: 'index',
                                                render: (text, record, recordIndex) => (
                                                    <span>{recordIndex + 1}</span>
                                                ),
                                            },
                                            {
                                                title: 'Food Name',
                                                dataIndex: 'product',
                                                render: (product) => product.name,
                                            },
                                            {
                                                title: 'Price (RM)',
                                                dataIndex: 'product',
                                                render: (product) => `RM${parseFloat(product.price).toFixed(2)}`,
                                            },
                                            {
                                                title: 'Quantity',
                                                dataIndex: 'quantity',
                                                render: (quantity) => quantity,
                                            },
                                            {
                                                title: 'Sub Menu',
                                                dataIndex: 'product',
                                                render: (product) => {
                                                    if (!product.addOns || product.addOns.length === 0) {
                                                        return null;
                                                    }

                                                    const groupedSubMenu = product.addOns.reduce((acc, item) => {
                                                        if (!acc[item.group]) {
                                                            acc[item.group] = [];
                                                        }
                                                        acc[item.group].push(item);
                                                        return acc;
                                                    }, {});

                                                    return (
                                                        <ul>
                                                            {Object.entries(groupedSubMenu).map(([group, items]) => (
                                                                <li key={group}>
                                                                    <strong>{group}</strong>
                                                                    <ul>
                                                                        {items.map((item, index) => (
                                                                            <li key={index}>
                                                                                {item.name} : RM {parseFloat(item.price).toFixed(2)}
                                                                            </li>
                                                                        ))}
                                                                    </ul>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    );
                                                },
                                            },

                                            {
                                                title: 'Remark',
                                                dataIndex: 'remarks',
                                                render: (remarks) => remarks,
                                            },
                                            {
                                                title: 'Void Reason',
                                                dataIndex: 'void_reason', // Ensure this matches the backend field name
                                                render: (void_reason) => {
                                                    // Map backend reason codes to readable text
                                                    const reasonMap = {
                                                        hygiene_problem: "Hygiene Problem",
                                                        waiting_too_long: "Waiting Too Long",
                                                        wrong_item: "Wrong Item",
                                                        other: "Other"
                                                    };
                                                    return (
                                                        <Tag color="red">
                                                            {reasonMap[void_reason] || void_reason}
                                                        </Tag>
                                                    );
                                                },
                                            },
                                        ]}
                                        dataSource={order.void_items || []}
                                    />
                                </Panel>
                            );
                        })}
                </Collapse>

                <>
                </>


            </Modal>

            <Modal
                open={editOrderVisible}
                title={
                    <div>
                        <CloseButton onClick={() => setEditOrderVisible(false)} />
                        Edit Order
                    </div>

                }
                onCancel={() => setEditOrderVisible(false)}
                footer={[
                    <Button key="cancel" onClick={() => setEditOrderVisible(false)}>
                        Cancel
                    </Button>,
                    <Button
                        key="submit"
                        type="primary"
                        onClick={async () => {
                            setIsSubmitted(true); // Trigger validation for null values
                            // Show the modal if validation fails
                            const validQuantity = currentOrder.quantity !== null && currentOrder.quantity > 0 && typeof currentOrder.quantity === "number";

                            if (validQuantity) {
                                // Proceed with the order update
                                await handleUpdateOrder(currentOrder, order);
                            } else {
                                // If there's an issue with quantity, show an error and keep modal open
                                message.error("Please fix the errors before submitting.");
                                setEditOrderVisible(true);
                            }
                        }}
                    >
                        Save
                    </Button>,
                ]}
            >
                {currentOrder && (
                    <Form layout="vertical">
                        <Form.Item
                            label={<span className="custom-label-remark">Food Name</span>}
                        >
                            <Input disabled={true} value={currentOrder.product.name} />
                        </Form.Item>

                        <Form.Item
                            label="Quantity"
                            validateStatus={validateStatus}
                            help={errorMsg}
                            required
                        >
                            <InputNumber
                                value={currentOrder.quantity}
                                onChange={(value) => {
                                    setCurrentOrder({ ...currentOrder, quantity: value });
                                    if (isSubmitted) setIsSubmitted(false); // Reset submission state on new input
                                }}
                                style={{ width: "100%" }}
                                className="no-spinner"
                            />
                        </Form.Item>

                        <Form.Item
                            label={<span className="custom-label-remark">Remark</span>}
                        >
                            <Input
                                value={currentOrder.remarks}
                                onChange={(e) =>
                                    setCurrentOrder({ ...currentOrder, remarks: e.target.value })
                                }
                            />
                        </Form.Item>

                        <Form.Item label={<span>Sub Menu</span>}>
                            {subMenu.length > 0 ? (
                                <div>
                                    {subMenu.map((submenu) => (
                                        <div key={submenu.id}>
                                            <h6>
                                                {submenu.group}
                                                {submenu.requirement === "required" && (
                                                    <span style={{ color: "red", marginLeft: "5px" }}>*</span>
                                                )}
                                            </h6>
                                            <ul style={{ listStyleType: "none", paddingLeft: 0 }}>
                                                {submenu.items.map((item) => (
                                                    <li key={item.id}>
                                                        {submenu.selection === "multiple" ? (
                                                            <Checkbox
                                                                value={item.name}
                                                                checked={currentOrder?.product?.addOns?.some(
                                                                    (addOn) => addOn.id === item.id
                                                                ) || false}
                                                                onChange={(e) => {
                                                                    const checked = e.target.checked;
                                                                    if (checked) {
                                                                        setCurrentOrder((prev) => ({
                                                                            ...prev,
                                                                            product: {
                                                                                ...prev.product,
                                                                                addOns: [
                                                                                    ...(prev.product?.addOns || []),
                                                                                    { ...item, group: submenu.group },
                                                                                ],
                                                                            },
                                                                        }));
                                                                    } else {
                                                                        setCurrentOrder((prev) => ({
                                                                            ...prev,
                                                                            product: {
                                                                                ...prev.product,
                                                                                addOns: (prev.product?.addOns || []).filter(
                                                                                    (addOn) => addOn.id !== item.id
                                                                                ),
                                                                            },
                                                                        }));
                                                                    }
                                                                }}
                                                            >
                                                                {item.name} ( + {symbol} {parseFloat(item.price).toFixed(2)} )
                                                            </Checkbox>
                                                        ) : (
                                                            <Radio.Group
                                                                value={
                                                                    currentOrder?.product?.addOns?.find(
                                                                        (addOn) => addOn.group === submenu.group && addOn.id === item.id
                                                                    )?.id
                                                                }
                                                                onChange={(e) => {
                                                                    const selectedId = e.target.value;
                                                                    const selectedItem = submenu.items.find(
                                                                        (i) => i.id === selectedId
                                                                    );
                                                                    setCurrentOrder((prev) => ({
                                                                        ...prev,
                                                                        product: {
                                                                            ...prev.product,
                                                                            addOns: [
                                                                                ...(prev.product?.addOns || []).filter(
                                                                                    (addOn) => addOn.group !== submenu.group
                                                                                ),
                                                                                { ...selectedItem, group: submenu.group },
                                                                            ],
                                                                        },
                                                                    }));
                                                                }}
                                                            >
                                                                <Radio value={item.id}>
                                                                    {item.name} ( + {symbol} {parseFloat(item.price).toFixed(2)} )
                                                                </Radio>
                                                            </Radio.Group>
                                                        )}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <p>No submenus available for this product.</p>
                            )}
                        </Form.Item>
                    </Form>
                )}
            </Modal>

            <Modal
                open={qrVisible}
                onOk={hideQrModal}
                onCancel={hideQrModal}
                footer={[
                    <Button
                        key="print"
                        type="primary"
                        onClick={() => printQrCode(`${tableNumber}`)}
                    >
                        Print
                    </Button>
                ]}
            >
                <div style={{ textAlign: "center", fontSize: "18px", fontWeight: "bold" }}>
                    QR Code
                </div>
                <div style={{ textAlign: "center", marginTop: "20px" }}>
                    <QRCode value={`${apiEndUserBaseUrl}/shop?table=${tableNumber}&token=${localStorage.getItem("adminToken")}`} />
                </div>
                <div style={{ textAlign: "center", marginTop: "10px", fontSize: "18px", fontWeight: "bold" }}>
                    Table {tableNumber}
                </div>
            </Modal>

            <Modal
                open={assignQue}
                onOk={assignTableSubmit}
                onCancel={hideAssignQue}
                title="Assign Table"
                bodyStyle={{ padding: '20px' }}
                centered

            >
                <div className="assign-que-select-wrapper">
                    <Select
                        placeholder="Please select a table"
                        onChange={(value) => setSelectedTable(value)}
                        size="large"
                        className="assign-que-select"
                        style={{ width: '100%' }}
                    >
                        {tables.map((table) => (
                            <Select.Option key={table._id} value={table.table_number}>
                                Table {table.table_number}
                            </Select.Option>
                        ))}
                    </Select>
                </div>
            </Modal>


        </div>
    )
}

export default QueList;